module.exports = __webpack_public_path__ + "img/RBC.f25d966b.png";